<template>
  <a-modal
    title="字典选择"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :footer="null"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :span="16">
            <a-form-item label="字典名称">
              <j-input placeholder="请输入字典名称" v-model="queryParam.dictName"></j-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery"  icon="search"></a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px"></a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"

        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleSelect(record)">选择</a>
        </span>

      </a-table>
    </div>
  </a-modal>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JInput from '@/components/jeecg/JInput'
  export default {
    name: 'DictSearchModal',
    components: { JInput },
    mixins:[JeecgListMixin],
    data(){
      return{
        visible:false,
        confirmLoading:false,
        columns: [
          {
            title: '字典名称',
            align:"center",
            ellipsis: true,
            dataIndex: 'dictName'
          },

          {
            title: '类型',
            align:"center",
            dataIndex: 'type_dictText'
          },
          {
            title: '描述',
            align:"center",
            ellipsis: true,
            dataIndex: 'description'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: ''
        },
        disableMixinCreated:true,
      }
    },
    methods:{
      view(url){
        this.url.list = url
        this.visible = true
        this.$nextTick(()=>{
          this.loadData()
        })
      },
      handleSelect(record){
        this.$emit('onSelect',record)
        this.handleCancel()
      },
      handleCancel(){
        this.visible =false
      }
    }
  }
</script>

<style scoped>

</style>